<template>
  <a-table
    class="table datatable thead-light dq-report-table"
    :columns="columns"
    :data-source="dataSource"
    :loading="loading"
    :pagination="false"
    row-key="key"
  >
    <template #bodyCell="{ column, record }">
      <template v-if="column.key === 'employee'">
        <div>
          <div class="fw-semibold">{{ record.employee_name }}</div>
          <div class="fs-12 text-muted">
            {{ record.employee_id }}
          </div>
        </div>
      </template>

      <template v-else-if="column.key === 'department'">
        <div class="fs-12">
          <div>{{ record.department || '-' }}</div>
          <div class="text-muted">{{ record.designation || '-' }}</div>
        </div>
      </template>

      <!-- Gross -->
      <template v-else-if="['prev_gross','curr_gross','diff_gross'].includes(column.key)">
        {{ currency }}
        {{
          Number(record[column.key] || 0).toLocaleString(undefined, {
            minimumFractionDigits: 2,
          })
        }}
      </template>

      <template v-else-if="column.key === 'pct_gross'">
        <span v-if="record.pct_gross !== null">
          <i
            v-if="record.diff_gross > 0"
            class="ti ti-arrow-up-right text-success me-1"
          ></i>
          <i
            v-else-if="record.diff_gross < 0"
            class="ti ti-arrow-down-right text-danger me-1"
          ></i>
          <i v-else class="ti ti-arrow-right text-muted me-1"></i>
          {{ Number(record.pct_gross).toFixed(2) }}%
        </span>
        <span v-else>-</span>
      </template>

      <!-- Net -->
      <template v-else-if="['prev_net','curr_net','diff_net'].includes(column.key)">
        {{ currency }}
        {{
          Number(record[column.key] || 0).toLocaleString(undefined, {
            minimumFractionDigits: 2,
          })
        }}
      </template>

      <template v-else-if="column.key === 'pct_net'">
        <span v-if="record.pct_net !== null">
          <i
            v-if="record.diff_net > 0"
            class="ti ti-arrow-up-right text-success me-1"
          ></i>
          <i
            v-else-if="record.diff_net < 0"
            class="ti ti-arrow-down-right text-danger me-1"
          ></i>
          <i v-else class="ti ti-arrow-right text-muted me-1"></i>
          {{ Number(record.pct_net).toFixed(2) }}%
        </span>
        <span v-else>-</span>
      </template>

      <!-- Fallback -->
      <template v-else>
        {{ record[column.dataIndex] }}
      </template>
    </template>
  </a-table>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
  rows: { type: Array, default: () => [] },
  loading: { type: Boolean, default: false },
  currency: { type: String, default: "KES" },
});

const columns = [
  {
    title: "Employee",
    dataIndex: "employee_name",
    key: "employee",
    fixed: "left",
    width: 180,
  },
  {
    title: "Department / Designation",
    dataIndex: "department",
    key: "department",
    width: 180,
  },
  {
    title: "Prev Gross",
    dataIndex: "prev_gross",
    key: "prev_gross",
    align: "right",
  },
  {
    title: "Curr Gross",
    dataIndex: "curr_gross",
    key: "curr_gross",
    align: "right",
  },
  {
    title: "Δ Gross",
    dataIndex: "diff_gross",
    key: "diff_gross",
    align: "right",
  },
  {
    title: "% Gross",
    dataIndex: "pct_gross",
    key: "pct_gross",
    align: "right",
  },
  {
    title: "Prev Net",
    dataIndex: "prev_net",
    key: "prev_net",
    align: "right",
  },
  {
    title: "Curr Net",
    dataIndex: "curr_net",
    key: "curr_net",
    align: "right",
  },
  {
    title: "Δ Net",
    dataIndex: "diff_net",
    key: "diff_net",
    align: "right",
  },
  {
    title: "% Net",
    dataIndex: "pct_net",
    key: "pct_net",
    align: "right",
  },
];

const dataSource = computed(() =>
  (props.rows || []).map((r, idx) => ({
    key: r.employee_id || idx,
    ...r,
  }))
);

const currency = computed(() => props.currency);
</script>

<style scoped>
@media (max-width: 767.98px) {
  :deep(.dq-report-table .ant-table) {
    min-width: 1280px;
  }

  :deep(.dq-report-table .ant-table-cell) {
    vertical-align: top;
    white-space: normal;
  }
}
</style>
